import React from "react";
import { RxCross2 } from "react-icons/rx";
import { motion } from "framer-motion";

const ExcitingNewsModal = ({ isOpen, onRequestClose }) => {
  if (!isOpen) return null;

  const newsItems = [
    {
      title: "🎉 New Course Launch!",
      description:
        "Advanced First Aid certification program now available with hands-on training sessions.",
      date: "January 2024",
    },
    {
      title: "💰 Special Offer - 20% Off",
      description:
        "Get 20% off on all group training sessions. Book now and save big on professional safety training!",
      date: "Limited Time",
    },
    {
      title: "🏆 Award Recognition",
      description:
        "ProSafe Training has been recognized as the leading safety training provider in Canada.",
      date: "December 2023",
    },
    {
      title: "📚 Updated Curriculum",
      description:
        "All our courses now include the latest safety protocols and industry best practices.",
      date: "Ongoing",
    },
  ];

  return (
    <div className="fixed inset-0 bg-black bg-opacity-30 z-[9999] flex items-center justify-center p-2 sm:p-4">
      <motion.div
        initial={{ opacity: 0, scale: 0.9 }}
        animate={{ opacity: 1, scale: 1 }}
        exit={{ opacity: 0, scale: 0.9 }}
        transition={{ duration: 0.3 }}
        className="bg-white rounded-2xl shadow-2xl max-w-2xl w-full mx-2 sm:mx-4 max-h-[90vh] overflow-y-auto p-4 sm:p-6 lg:p-8 relative"
        onClick={(e) => e.stopPropagation()}
      >
        <button
          onClick={onRequestClose}
          className="absolute top-2 right-2 sm:top-4 sm:right-4 p-1.5 sm:p-2 rounded-full hover:bg-gray-100 transition-colors duration-200 z-10"
        >
          <RxCross2 className="h-5 w-5 sm:h-6 sm:w-6 text-gray-600" />
        </button>

        <div className="text-center mb-4 sm:mb-6 lg:mb-8 pr-8 sm:pr-0">
          <motion.h2
            initial={{ opacity: 0, y: -20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
            className="text-xl sm:text-2xl lg:text-3xl font-bold text-[#183864] mb-2"
          >
            🚀 Exciting Updates & Offers!
          </motion.h2>
          <p className="text-sm sm:text-base text-gray-600">
            Stay updated with our latest news and special offers
          </p>
        </div>

        <div className="space-y-3 sm:space-y-4 lg:space-y-6">
          {newsItems.map((item, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, x: -20 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              className="bg-gradient-to-r from-[#E5EDFF] to-[#F0F4FF] p-3 sm:p-4 lg:p-6 rounded-xl border-l-4 border-[#183864] hover:shadow-lg transition-shadow duration-300"
            >
              <div className="flex flex-col sm:flex-row sm:justify-between sm:items-start mb-2 sm:mb-3">
                <h3 className="text-lg sm:text-xl font-semibold text-[#183864] mb-1 sm:mb-0 pr-2">
                  {item.title}
                </h3>
                <span className="text-xs sm:text-sm text-gray-500 bg-white px-2 sm:px-3 py-1 rounded-full self-start whitespace-nowrap">
                  {item.date}
                </span>
              </div>
              <p className="text-sm sm:text-base text-gray-700 leading-relaxed">
                {item.description}
              </p>
            </motion.div>
          ))}
        </div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: 0.5 }}
          className="mt-4 sm:mt-6 lg:mt-8 text-center"
        >
          <button
            onClick={onRequestClose}
            className="bg-[#B02526] hover:bg-[#8B1E1F] text-white font-semibold px-6 sm:px-8 py-2.5 sm:py-3 rounded-lg transition-colors duration-300 transform hover:scale-105 text-sm sm:text-base"
          >
            Close
          </button>
        </motion.div>
      </motion.div>
    </div>
  );
};

export default ExcitingNewsModal;
